export default __webpack_public_path__ + "static/media/family-and-friends.f9cc7daf.svg";